/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

import { __ } from '@oat-sa-private/ui-core';
import { guidedNavigationKinds } from './timers/navigation.js';

export function getGuidedNavigationDisabledMessage() {
    return __('Test navigation is currently disabled. Next question will be available shortly.');
}

export function getGuidedNavigationDisabledTooltipMessage(kind) {
    if (kind === guidedNavigationKinds.timer) {
        return __('Test navigation is currently disabled due to a timer.');
    }

    if (kind === guidedNavigationKinds.sequence) {
        return __('Test navigation is currently disabled due to a running media sequence.');
    }

    return getGuidedNavigationDisabledMessage();
}
